import SharedLayouts from "../Layouts/SharedLayout";
import * as rsuite from 'rsuite';
import {
  useReactTable,
  getCoreRowModel,
} from "@tanstack/react-table";
import useToaster from 'rsuite/useToaster';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import * as General from '../General/General';
import { useNavigate } from "react-router-dom";
import CrudPageHeader from "../components/CrudPageHeader";
import DataTable from "../components/DataTable";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import CrudFormModal from "../components/CrudFormModal";

const Product = () => {
    //#region const
    const navigate = useNavigate();
    const toaster = useToaster();
    const [ShowModal, setShowModal] = useState(false);
    const [Image, setImage] = useState();
    const [ImageName, setImageName] = useState("");
    const [PrevImageName, setPrevImageName] = useState("");
    const [Title, setTitle] = useState("");
    const [Header, setHeader] = useState("");
    const [Description, setDescription] = useState("");
    const [CategoryId, setCategoryId] = useState(General.GuidEmpty());
    const [Categories, setCategories] = useState([]);
    const [ShowDeleteModal, setShowDeleteModal] = useState(false);
    const [Order,setOrder] = useState(0);
    const [ErrorMsg, setErrorMsg] = useState("");
    //#endregion
    //#region Handler

    const ImageCheck = (e) => {
        setImage(e.target.files[0]); // Set the file to Image state
        setImageName(e.target.files[0].name);
    }

    //#endregion
    //#region method
    const clearDependecies = () => {
        setCategoryId(General.GuidEmpty());
        setTitle("");
        setHeader("");
        setDescription("");
        setImageName("");
        setPrevImageName("");
        setImage(null);
    }
    const Delete = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/category/delete/' + CategoryId,
            method: "delete",
            headers: General.AuthHeader(),
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setErrorMsg("");
                    toaster.push(General.ShowMessage('success', 'عملیات حذف با موفقیت انجام شد'), 'topCenter');
                    GetCategories();
                    setCategoryId(General.GuidEmpty());
                    setShowDeleteModal(false);
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در انجام عملیات';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetCategoryById = (Id) => {
        setCategoryId(Id);
        var RequestOption = {
            url: General.ApiRoot() + '/category/getById/' + Id,
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    const row = result.data && result.data[0];
                    if (row) {
                        setTitle(row.Title);
                        setHeader(row.Header);
                        setDescription(row.Description);
                        setPrevImageName(row.FileName);
                        setOrder(row.Order);
                        setShowModal(true);
                    }
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }
    const GetCategories = () => {
        var RequestOption = {
            url: General.ApiRoot() + '/category/getAll',
            method: "get",
        };

        trackPromise(
            axios(RequestOption)
                .then(function (result) {
                    setCategories(result.data)
                }).catch((error) => {
                    const msg = error?.response?.data?.message || 'خطا در برقراری ارتباط با سرور';
                    setErrorMsg(msg);
                    toaster.push(General.ShowMessage('error', msg), 'topCenter');
                })
        );
    }

    const AddNewProduct = () => {
        setShowModal(true);
    }
    const CheckValidation = () => {
        if (Title == "") {
            setErrorMsg('لطفا عنوان را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا عنوان را وارد کنید'), 'topCenter');
            return false;
        }
        else if (Description == "") {
            setErrorMsg('لطفا توضیحات را وارد کنید');
            toaster.push(General.ShowMessage('error', 'لطفا توضیحات را وارد کنید'), 'topCenter');
            return false;
        }
        else {
            return true;
        }
    }
    const Save = () => {
        if (CheckValidation()) {
            setErrorMsg("");
            const isNew = CategoryId === General.GuidEmpty();
            const formData = new FormData();
            formData.append('FormFile', Image); // Ensure Image is correctly set
            formData.append('FileName', ImageName);
            formData.append('Title', Title);
            formData.append('Header', Header);
            formData.append('Description', Description);
            formData.append('Id', CategoryId);
            formData.append('PrevFileName', PrevImageName);
            formData.append('Order', Order);
            const requestOptions = {
                url: General.ApiRoot() + '/category/' + (isNew ? 'add' : 'update'),
                method: "post",
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    ...General.AuthHeader(),
                },
            };

            trackPromise(
                axios(requestOptions)
                    .then(function (result) {
                        toaster.push(General.ShowMessage('success', 'عملیات با موفق انجام شد'), 'topCenter');
                        GetCategories();
                        clearDependecies();
                        if (!isNew) {
                            setShowModal(false);
                        }
                    }).catch((error) => {
                        const msg = error?.response?.data?.message || 'عملیات با خطا مواجه شد';
                        setErrorMsg(msg);
                        toaster.push(General.ShowMessage('error', msg), 'topCenter');
                    })
            );
        }
    }
    //#endregion

    const columns = [
        {
            id: "title",
            header: () => <div className="text-right">عنوان محصول</div>,
            cell: ({ row }) => <div className="">{row.original.Title}</div>,
        },
        {
            id: "header",
            header: () => <div className="text-right">هدر</div>,
            cell: ({ row }) => <div className="">{row.original.Header}</div>,
        },
        {
            id: "order",
            header: () => <div className="text-right">ترتیب نمایش</div>,
            cell: ({ row }) => <div className="">{row.original.Order}</div>,
        },
        {
            id: "image",
            header: () => <div className="text-right">عکس</div>,
            cell: ({ row }) => <div className="">
                <img
                    className="w-2/4"
                    src={row.original.ImageUrl}
                    alt={row.original.Title || "تصویر"}
                />
            </div>,
        },
        General.actionsColumn(GetCategoryById, (id) => (setCategoryId(id), setShowDeleteModal(true))),
    ];

    const table = useReactTable({
        data: Categories,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    useEffect(() => {
        // Check if the user is authenticated
        if (!General.isLoggedIn()) {
          navigate('/'); // Redirect to login if not authenticated
        }
        else{
            GetCategories();
        }
      }, []);

    return (
        <SharedLayouts>
            <div className="bg-white h-screen w-full px-2">
                {ErrorMsg && (
                    <rsuite.Message type="error" showIcon closable onClose={() => setErrorMsg("")} className="mb-2">
                        {ErrorMsg}
                    </rsuite.Message>
                )}
                <CrudPageHeader title="محصولات" onAdd={AddNewProduct} />
                <DataTable table={table} />
            </div>

            <CrudFormModal
                open={ShowModal}
                title="تعریف محصول جدید"
                onClose={() => (setShowModal(false), clearDependecies())}
                onSave={Save}
            >
                <rsuite.Row>
                    <label>عنوان</label>
                    <rsuite.Input onChange={e => setTitle(e)} value={Title} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>هدر</label>
                    <rsuite.Input value={Header} onChange={e => setHeader(e)} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>ترتیب نمایش</label>
                    <rsuite.InputNumber value={Order} onChange={e => setOrder(e)} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>انتخاب عکس</label>
                    <rsuite.Input type="file" onInput={ImageCheck} className="mt-1 mb-3" />
                </rsuite.Row>
                <rsuite.Row>
                    <label>توضیحات</label>
                    <rsuite.Input as="textarea" value={Description} onChange={e => setDescription(e)} rows={3} className="mt-1 mb-3" />
                </rsuite.Row>
            </CrudFormModal>

            <ConfirmDeleteModal
                open={ShowDeleteModal}
                message="آیا از حذف محصول مطمئن هستید؟در صورت حذف قادر به بازیابی اطلاعات نخواهید بود."
                onConfirm={Delete}
                onCancel={() => (setShowDeleteModal(false), setCategoryId(General.GuidEmpty()))}
            />
        </SharedLayouts>
    )
}
export default Product;
